/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_ValidationInputs */

const cs_api_error_validation = /** @type {(inputs: Api_Error_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkontrolujte označená pole a zkuste to znovu.`)
};

const en_api_error_validation = /** @type {(inputs: Api_Error_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check the highlighted fields and try again.`)
};

/**
* | output |
* | --- |
* | "Please check the highlighted fields and try again." |
*
* @param {Api_Error_ValidationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_validation = /** @type {((inputs?: Api_Error_ValidationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_ValidationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_validation(inputs)
	return cs_api_error_validation(inputs)
});